export default __webpack_public_path__ + "static/O0093-cedbcc7fa569043cf0f6ce412dddf2a0.png";